import React from 'react';
import PropTypes from 'prop-types';
import FindIcon from '@material-ui/icons/Search';

const FindButton = ({ code }) => (
  <button
    data-cmscode={code}
  >
    <span style={{ color: '#fff' }}>
      <FindIcon />
    </span>
  </button>
);

FindButton.propTypes = {
  code: PropTypes.string.isRequired
};

export default FindButton;
